import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback, Input } from "reactstrap";

import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { saveAs } from 'file-saver';
import Papa from "papaparse";

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}


const TransactionsReport = props => {
  //meta title
  document.title = "Transactions Report";
  const { getRequest, postRequest } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      status: 'All',
      currency: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = TransactionData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.currency !== 'All') {
            filteredData = filteredData.filter(item => item.currency === values.currency);
          }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setTransactionTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [WalletAddress, setWalletAddress] = React.useState('');
  const [Tokens, setTokens] = React.useState('');
  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      pct_id: elementData.pct_id,
      status: elementData.status,
    });
    setWalletAddress(elementData.wallet_address);
    setTokens(elementData.token);
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      pct_id: '',
      status: '',
      hash: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
      hash: Yup.string().when('status', {
        is: 'Approved',
        then: (schema) => schema.required("Transaction Hash is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          pct_id: values.pct_id,
          status: values.status,
          hash: values.hash,
        });
        const res = await postRequest('update-property-crypto-transaction-status-manual', jsonpar);
        if (res && res.code === 200) {
            validation2.resetForm();
            
            setTimeout(() => {
              validation1.handleSubmit();
            }, 500);

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        handleLoadGetTransactionData();
        
        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [FilePath, setFilePath] = React.useState('');
  const [TransactionData, setTransactionData] = React.useState([]);
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const [CsvData, setCsvData] = React.useState([]);

  const handleT1Body = async (tempData) => {
    setCsvData(tempData);

    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.pct_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.token_symbol || '-'}</td>
        <td>{element.token}</td>
        <td>{element.currency}</td>
        <td>{parseFloat(element.received_amount)} &nbsp;{element.currency}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-property-crypto-transaction-data');
    if (res && res.code === 200) {
      setCsvData(res.data.transaction)
      handleT1Body(res.data.transaction);
      setTransactionData(res.data.transaction);
      setFilePath(res.data.url);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="10" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  
  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let tempArr = [{label: 'All', value: 'All'}];
      res.data.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersData(tempArr);
    }
  }

  const handleDownloadCSV = () => {

    const transformedData = CsvData.map(transaction => ({
      "First Name": transaction.first_name,
      "Last Name": transaction.last_name,
      "Email": transaction.email,
      "Property": transaction.token_symbol || '-',
      "Token": transaction.token,
      "Currency": transaction.currency,
      "Amount": parseFloat(transaction.received_amount) +" "+transaction.currency,
      "Date": moment(transaction.created_at).format('YYYY-MM-DD | HH:mm'),
      "Status": transaction.status
    }));
    
    const csv = Papa.unparse(transformedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "TransactionData.csv");
  };

  // Add HubSpot configuration
  const [isHubSpotSyncing, setIsHubSpotSyncing] = React.useState(false);

  const syncToHubSpot = async () => {
    try {
      setIsHubSpotSyncing(true);
      let submitBtn = document.getElementById('submit4');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Syncing...';
      }

      const hubspotData = CsvData.map(transaction => ({
        properties: {
          firstname: transaction.first_name,
          lastname: transaction.last_name,
          email: transaction.email,
          property: transaction.token_symbol || '-',
          token: transaction.token,
          currency: transaction.currency,
          amount: Number(transaction.received_amount) || 0,
          date: moment(transaction.created_at).valueOf(),
          status: transaction.status,
        }
      }));

      // Send to backend API endpoint
      const jsonpar = JSON.stringify({
        transactions: hubspotData
      });
      
      const res = await postRequest('sync-transaction-data-to-hubspot', jsonpar);
      
      if (res && res.code === 200) {
        setAlertData({
          variant: 'success',
          message: `Successfully synced ${hubspotData.length} transactions to HubSpot`,
        });
      } else {
        setAlertData({
          variant: 'error',
          message: res.message || 'Failed to sync to HubSpot',
        });
      }
      resetAlertData();

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sync to HubSpot';
      }
      setIsHubSpotSyncing(false);
    } catch (error) {
      console.error("HubSpot sync error:", error);
      setAlertData({
        variant: 'error',
        message: 'Error syncing to HubSpot',
      });
      resetAlertData();
      setIsHubSpotSyncing(false);
      let submitBtn = document.getElementById('submit4');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sync to HubSpot';
      }
    }
  };

  React.useEffect(() => {
    handleLoadGetTransactionData();
    handleLoadGetUsers();
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Transactions Report")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="row">
                    <Col md={3} xs={12}>
                      <div className="mb-3 Register-Select2">
                        <label className="form-label">Users : </label>
                        <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersData} classNamePrefix="select2-selection" />
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label">Status : </label>
                        <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                          <option value={'All'}>All</option>
                          <option value={'Pending'}>Pending</option>
                          <option value={'Approved'}>Approved</option>
                          <option value={'Cancelled'}>Cancelled</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label">Currency : </label>
                        <select className="form-select" name="currency" value={validation1.values.currency} onChange={(e) => validation1.setValues({ ...validation1.values, currency: e.target.value })}>
                          <option value={'All'}>All</option>
                          <option value={'Euro'}>Euro</option>
                          <option value={'USDT'}>USDT</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <label className="form-label fullWidth">&nbsp; </label>
                        <Button type="button" id="submit1" onClick={(e) => { e.preventDefault(); validation1.handleSubmit(); return false; }} color="primary" style={{ float: "left"}} >Search</Button>
                        <Button type="button" id="submit3" onClick={handleDownloadCSV} color="primary" className="bx bx-download" style={{ float: "right", marginLeft: "10px"}}></Button>
                      </div>
                    </Col>
                    <Col md={3} xs={12}>
                      <div className="mb-3">
                        <Button type="button" id="submit4" onClick={syncToHubSpot} color="primary" disabled={isHubSpotSyncing || CsvData.length === 0} style={{ float: "left"}}>
                          Sync to HubSpot
                        </Button>
                      </div>
                    </Col>
                  </div>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ minWidth: '1000px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email ID</th>
                          <th>Property</th>
                          <th>Tokens</th>
                          <th>Currency</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {TransactionTBody}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(TransactionsReport);
